import type { UnifiedEventsName } from 'owa-analytics-types';

/**
 * Active legacy mappings - OWA events that exist in the data catalog and map to Unified Telemetry events.
 * These events are currently being logged and have corresponding UT event names.
 */
const activeMappings: {
    [key: string]: UnifiedEventsName;
} = {
    // Mail events
    TnS_DeleteItem: 'DeleteMail', // ✔️ Added and working
    TnS_DeleteConversation: 'DeleteMail', // ✔️ Added and working
    TnS_CreateFolder: 'CreateFolder', // ✔️ Added and working
    FlagUnflagMail: 'FlagUnflagMail', // ✔️ Added and working
    TnS_MarkConversationRead: 'MarkReadUnreadMail', // ✔️ Added and working
    TnS_MarkConversationUnread: 'MarkReadUnreadMail', // ✔️ Added and working
    TnS_MarkItemRead: 'MarkReadUnreadMail', // ✔️ Added and working
    TnS_MarkItemUnread: 'MarkReadUnreadMail', // ✔️ Added and working
    // UT_TODO: Find legacy event that related to "EditDraft" event
    ComposeMessage: 'ComposeMessage', // ❌ Couldn't find the "EditDraft" operation
    GroupMailComposeSend: 'SendMessage', // ❌ Need to add all the sub actions
    MailComposeSend: 'SendMessage', // ❌ Need to add all the sub actions
    TnS_SelectFocusedPivot: 'SwitchFocusedOther', // ✔️ Added and working
    TnS_SelectOtherPivot: 'SwitchFocusedOther', // ✔️ Added and working

    // Attachment events
    AttachmentCreation: 'AddAttachment', // ❌ Need to add all the sub actions (same for all attachement events)
    AttachmentDownload: 'DownloadAttachment', // ❌ Need to add all the sub actions (same for all attachement events)
    PreviewAttachmentInSxSE2E: 'ViewAttachment', // ❌ Need to add all the sub actions (same for all attachement events)

    // Contact events
    SaveContact: 'SaveContact', // ⚠️ Added
    DeleteContact: 'DeleteContact', // ⚠️ Added
    LPCRenderedFromHoverTarget: 'ViewContact', // ⚠️ Added
    LPCRenderedFromOnOpenLPC: 'ViewContact', // ⚠️ Added
    ViewContact: 'ViewContact', // ⚠️ Added
    ViewListOfAccountContacts: 'ViewListOfAccountContacts', // ⚠️ Added

    // Search events
    Search_SuggestionsE2E: 'PerformSearch', // ✔️ Added and working
    PerformSearch: 'PerformSearch',

    // Calendar events
    SaveCalendarEvent: 'SaveCalendarEvent', // ❌ Couldn't find the attendee count
    LoadCalendarModuleE2E: 'LoadCalendar', // ✔️ Added and working
    SwitchCalendarView: 'SwitchCalendarView', // ✔️ Added and working
    ViewCalendarEvent: 'ViewCalendarEvent', // ❌ Couldn't find attendee count
    CalendarCopilotUserAction: 'CalendarCopilotUserAction',
    CalendarFeatureLatency: 'CalendarFeatureLatency',

    // Generic action
    GenericAction: 'GenericAction', // ✔️ Added and working

    // Places events
    PlacesWorkspacesCreateReservation: 'PlacesBookReservation', // ✔️ Added and working
    PlacesWorkspacesBooking: 'PlacesBookReservation', // ✔️ Added and working
    PlacesSetWorkRoutine: 'PlacesSetWorkRoutine', // ⚠️ Added
    PlacesDashboardLoadE2E: 'PlacesDashboardLoadE2E', // ✔️ Added and working
    PlacesHomepageV3LoadE2E: 'PlacesBootExplorePageE2E', // ✔️ Added and working
    PlacesMapsLoadE2E: 'PlacesMapsLoadE2E', // ⚠️ Added
    PlacesNoWorkDaysStateAction: 'PlacesNoWorkDaysStateAction',
    PlacesCollaboratorsAddButton: 'PlacesAddCollaboratorE2E',
    PlacesCollaboratorsSearchButton: 'PlacesAddCollaboratorE2E',
    PlacesCollaboratorsDelete: 'PlacesDeleteCollaboratorE2E',
    GetPlaceSuggestionsUserLatency: 'PlacesFinderLoadE2E',
    PlacesAgendaPanelLoadE2E: 'PlacesAgendaPanelLoadE2E',
    PlacesPageLoaderE2E: 'PlacesPageLoaderE2E',
    PlacesCheckIntoBuildingE2E: 'PlacesCheckIntoBuildingE2E',
    PlacesFeatureLatency: 'PlacesFeatureLatency',
    FETCH_PLACES_SETTINGS: 'PlacesUserSettings',

    // Work Plan events
    OpenWorkPlanPeek: 'OpenWorkPlanPeek',
    WorkPlanImpressions: 'WorkPlanImpressions',
    OpenWorkPlansOnboardingPeek: 'OpenWorkPlansOnboardingPeek',
    OpenWorkPlanExpandedView: 'OpenWorkPlanExpandedView',
    WorkPlanPeekSuggestionQueued: 'WorkPlanPeekSuggestionQueued',
    WorkPlanPeekSuggestionViewed: 'WorkPlanPeekSuggestionViewed',
    WorkPlanPeekCardUserAction: 'WorkPlanPeekCardUserAction',
    PlacesSetWorkPlanOOF: 'PlacesSetWorkPlanOOF',
    OpenWorkPlansOnboardingSetPlan: 'OpenWorkPlansOnboardingSetPlan',
    TodaysOthersInOfficeLoaded: 'TodaysOthersInOfficeLoaded',
    OpenTodaysOthersInOfficePeek: 'OpenTodaysOthersInOfficePeek',
    TodaysOthersInOfficePeekDateNavigation: 'TodaysOthersInOfficePeekDateNavigation',

    // Hybrid Guidance events
    HybridGuidanceLoadWorkGroups: 'HybridGuidanceLoadWorkGroups',
    HybridGuidanceCreateGuidance: 'HybridGuidanceCreateGuidance',
    HybridGuidanceUpdateGuidance: 'HybridGuidanceUpdateGuidance',

    // QuickBook events
    QuickBookSuggestionsLoadE2E: 'QuickBookSuggestionsLoadE2E',
    QuickBookRoomRequestE2E: 'QuickBookRoomRequestE2E',
    QuickBookModalInteractionTime: 'QuickBookModalInteractionTime',
};

/**
 * Deprecated legacy mappings - OWA events that NO LONGER exist in the data catalog.
 * These events may have been removed, renamed, or are no longer being logged.
 * Kept here for reference and potential future cleanup.
 *
 * @deprecated These mappings are not active and may be removed in the future.
 */
const deprecatedMappings: {
    [key: string]: string;
} = {
    // Mail events
    TnS_Move: 'MoveMessage', // ✔️ Added and working
    MailComposeNew: 'ComposeMessage', // ✔️ Added and working

    // Calendar events
    TBD18: 'DeleteCalendarEvent', // ❌ Missing AttendeeCount and SubAction mapping

    // Places events
    PlacesOpenPlacesFinder: 'PlacesOpenPlacesFinder', // ⚠️ Added
    PlacesSetWorkPlan: 'PlacesSetWorkPlan', // ✔️ Added and working
    PlacesViewConnections: 'PlacesViewConnections', // ⚠️ Added
    PlacesConnectionsEdited: 'PlacesConnectionsEdited', // ⚠️ Added
    PlacesViewAdminPortal: 'PlacesViewAdminPortal', // ✔️ Added and working,
    PlacesAppLoad: 'PlacesAppLoad', // ✔️ Added and working,
    PlacesWelcomeShown: 'PlacesWelcomeShown', // ✔️ Added and working,
    PlacesAdminAction: 'PlacesAdminAction', // ⚠️ Added
    PlacesNavigationClick: 'PlacesNavigationClick', // ✔️ Added and working
    PlacesSetDayForAgendaView: 'PlacesSetDayForAgendaView',
    PlacesComponentViewChange: 'PlacesComponentViewChange',
    PlacesWorkGroupManagement: 'PlacesWorkGroupManagement',
    PlacesWorkGuidanceManagement: 'PlacesWorkGuidanceManagement',
    PlacesWorkGuidanceInteraction: 'PlacesWorkGuidanceInteraction',
    PlacesExploreCollaboratorsView: 'PlacesExploreCollaboratorsView',
    PlacesPageLoad: 'PlacesPageLoad',
    PlacesExploreCardInteraction: 'PlacesExploreCardInteraction',
    PlacesPeopleInteraction: 'PlacesPeopleInteraction',
    PlacesWorkGroupsInteraction: 'PlacesWorkGroupsInteraction',
    PlacesPeopleSidebarInteraction: 'PlacesPeopleSidebarInteraction',
    PlacesTimestripSelectDate: 'PlacesTimestripSelectDate',
    PlacesFinderFirstInteraction: 'PlacesFinderFirstInteraction',
    PlacesClosePlacesFinder: 'PlacesClosePlacesFinder',
    PlacesBuildingNavigation: 'PlacesBuildingNavigation',
    PlacesHybridGuidanceLoadE2E: 'HybridGuidancePageLoadE2E', // https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web/pullrequest/222438
    PlacesGuidanceCardsLoad: 'PlacesGuidanceCardsLoad', // https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web/pullrequest/222438

    // Work Plan events
    PlaceWorkplaceCopilotFeedback: 'PlaceWorkplaceCopilotFeedback',
    WorkPlanPeekSuggestionBackgroundEvent: 'WorkPlanPeekSuggestionBackgroundEvent',
    OpenDeskReservationForm: 'OpenDeskReservationForm',

    // Hybrid Guidance events
    HybridGuidanceViewWorkGroup: 'HybridGuidanceViewWorkGroup',

    // QuickBook events
    QuickBookModalAction: 'QuickBookModalAction',
    QuickBookLoadedInPeek: 'QuickBookLoadedInPeek',
    DeskBookLoadedInPeek: 'DeskBookLoadedInPeek',
    QuickBookSuggestionInteraction: 'QuickBookSuggestionInteraction',

    // Other events
    MapInteraction: 'MapInteraction',
    RoomFinderSelectPlace: 'RoomFinderSelectPlace',
};

/**
 * Combined legacy mappings for backward compatibility.
 * Only active mappings are included - deprecated mappings are excluded from runtime usage.
 */
const legacyMappings: {
    [key: string]: UnifiedEventsName;
} = {
    ...activeMappings,
};

export function matchEventDefinition(eventName: string): UnifiedEventsName | string | undefined {
    return legacyMappings[eventName];
}

/**
 * Returns the deprecated mappings for reference/debugging purposes.
 * These events no longer exist in the data catalog.
 */
export function getDeprecatedMappings(): {
    [key: string]: string;
} {
    return deprecatedMappings;
}
